import { render } from "./Pulmonology.vue?vue&type=template&id=3f5c38cb&scoped=true"
import script from "./Pulmonology.vue?vue&type=script&lang=ts"
export * from "./Pulmonology.vue?vue&type=script&lang=ts"

import "./Pulmonology.vue?vue&type=style&index=0&id=3f5c38cb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3f5c38cb"

export default script